import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ArrowForwardFloatingProps = IconComponentBaseProps;

export const ArrowForwardFloating = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: ArrowForwardFloatingProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_7287_7411"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
        className={className}
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7287_7411)">
        <path
          d="M15.9335 12L8.21829 4.2845C8.07079 4.13717 7.99804 3.96 8.00004 3.753C8.00187 3.54583 8.07654 3.36858 8.22404 3.22125C8.37137 3.07375 8.54862 3 8.75579 3C8.96279 3 9.14004 3.07375 9.28754 3.22125L16.924 10.8635C17.0855 11.025 17.2035 11.2051 17.2778 11.4038C17.3521 11.6026 17.3893 11.8013 17.3893 12C17.3893 12.1987 17.3521 12.3974 17.2778 12.5963C17.2035 12.7949 17.0855 12.975 16.924 13.1365L9.28154 20.7788C9.13421 20.9263 8.95796 20.999 8.75279 20.997C8.54762 20.9952 8.37137 20.9205 8.22404 20.773C8.07654 20.6257 8.00279 20.4484 8.00279 20.2413C8.00279 20.0343 8.07654 19.857 8.22404 19.7095L15.9335 12Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
